import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MainForm } from "./forms/mainForm";
import PageHeader from "../../components/heading";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { UserQuery, useUserQuery } from "../../graphql/menu.hooks";

export type DomainItem = UserQuery["user"]["domains"][number];

export const PageSettings = () => {
  const queryParams = new URLSearchParams(location.search);
  const { t } = useTranslation();
  const { id } = useParams<{ id: string; projectId: string }>();
  const { data: user } = useUserQuery();
  const isEdit = !!id;
  const lng = useGetUrlLocale();
  const projectId = queryParams.get("projectId");
  const params = new URLSearchParams(window.location.search);
  const shared = params.has("Shared");
  let domainTitle = "";
  if (!shared && projectId) {
    domainTitle =
      user?.user.domains.find(({ id }: DomainItem) => id === +projectId)
        ?.title || "";
  }
  useEffect(() => {
    document.title = isEdit ? "Edit Page Settings" : "Create Page Settings";
  }, [isEdit]);

  return (
    <>
      <PageHeader
        title={isEdit ? t("page.settings") : t("page.new")}
        paths={[
          ...(isEdit
            ? []
            : !shared
              ? [
                  { label: t("projects.main"), path: `${lng}/projects/` },
                  { label: domainTitle, path: `${lng}/projects/${projectId}` },
                  {
                    label: t("page.new"),
                    path: `${lng}/projects/${projectId}/page/create`,
                  },
                ]
              : [{ label: t("menu.shared"), path: `${lng}/shared/` }]),
        ]}
        isHiddenDropdown={true}
        isHiddenTryPro={true}
      />

      <div className="container px-0">
        <MainForm isEdit={isEdit} />
      </div>
    </>
  );
};
